import React, { useState } from "react";
import { ArrowLeft, Eye, EyeOff, LockKeyhole, Mail, Smartphone } from "lucide-react";
import "../styles/Login.css";

function Login() {
  const [showPassword, setShowPassword] = useState(false);
  const [credentials, setCredentials] = useState({ email: "", password: "" });
  const [message, setMessage] = useState("");
  const [role, setRole] = useState("Employee");
  const [showRecovery, setShowRecovery] = useState(false);
  const [recovery, setRecovery] = useState({ email: "", mobile: "" });

  const handleChange = (event) => {
    setCredentials({
      ...credentials,
      [event.target.name]: event.target.value,
    });
    setMessage("");
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    setMessage("Login service is ready to be connected to your HR system.");
  };

  const handleRecoverySubmit = (event) => {
    event.preventDefault();
    setMessage("Recovery details are ready. Connect your account recovery service to send reset instructions.");
  };

  return (
    <main className="login-page">
      <section className={`login-card${showRecovery ? " login-card--recovery" : ""}`} aria-labelledby="login-title">
        {showRecovery ? (
          <>
            <button className="login-back" type="button" onClick={() => { setShowRecovery(false); setMessage(""); }}>
              <ArrowLeft aria-hidden="true" /> Back to sign in
            </button>
            <div className="login-card__intro">
              <span className="login-card__eyebrow">ACCOUNT RECOVERY</span>
              <h1 id="login-title">Forgot your password?</h1>
              <p className="login-card__subtitle">Enter the email and mobile number registered to your account.</p>
            </div>
            <form className="login-form" onSubmit={handleRecoverySubmit}>
              <label htmlFor="recovery-email">Email</label>
              <div className="login-input-wrap">
                <Mail aria-hidden="true" />
                <input id="recovery-email" type="email" value={recovery.email} onChange={(event) => setRecovery({ ...recovery, email: event.target.value })} placeholder="name@example.com" autoComplete="email" required />
              </div>
              <label htmlFor="recovery-mobile">Registered mobile number</label>
              <div className="login-input-wrap">
                <Smartphone aria-hidden="true" />
                <input id="recovery-mobile" type="tel" value={recovery.mobile} onChange={(event) => setRecovery({ ...recovery, mobile: event.target.value })} placeholder="Enter your mobile number" autoComplete="tel" required />
              </div>
              <button className="login-submit" type="submit">Continue</button>
              {message && <p className="login-message" role="status">{message}</p>}
            </form>
          </>
        ) : (
          <>
        <div className="login-card__intro">
          {/*<span className="login-card__eyebrow">TECHLYNX PORTAL</span>*/}
          <h1 id="login-title">Sign in to access your workspace</h1>
          <p className="login-card__subtitle">Choose your account type to continue.</p>
          <div className="login-roles" role="group" aria-label="Choose account type">
            {["Employee", "Admin", "Job-Seeker"].map((option) => (
              <button
                key={option}
                type="button"
                className={`login-role${role === option ? " is-selected" : ""}`}
                aria-pressed={role === option}
                onClick={() => setRole(option)}
              >
                <span className="login-role__dot" aria-hidden="true" />
                {option}
              </button>
            ))}
          </div>
        </div>

        <form className="login-form" onSubmit={handleSubmit}>
          <label htmlFor="login-email">Email</label>
          <div className="login-input-wrap">
            <Mail aria-hidden="true" />
            <input
              id="login-email"
              name="email"
              type="email"
              value={credentials.email}
              onChange={handleChange}
              placeholder="name@company.com"
              autoComplete="email"
              required
            />
          </div>

          <label htmlFor="login-password">Password</label>
          <div className="login-input-wrap">
            <LockKeyhole aria-hidden="true" />
            <input
              id="login-password"
              name="password"
              type={showPassword ? "text" : "password"}
              value={credentials.password}
              onChange={handleChange}
              placeholder="Enter your password"
              autoComplete="current-password"
              required
            />
            <button
              type="button"
              className="login-password-toggle"
              onClick={() => setShowPassword((current) => !current)}
              aria-label={showPassword ? "Hide password" : "Show password"}
            >
              {showPassword ? <EyeOff aria-hidden="true" /> : <Eye aria-hidden="true" />}
            </button>
          </div>

          <div className="login-form__options">
            <label className="login-remember">
              <input type="checkbox" />
              <span>Remember me</span>
            </label>
            <button className="login-forgot" type="button" onClick={() => { setShowRecovery(true); setMessage(""); }}>
              Forgot password?
            </button>
          </div>
          <button className="login-submit" type="submit">Sign in as {role}</button>
          {message && <p className="login-message" role="status">{message}</p>}
        </form>
          </>
        )}
      </section>
    </main>
  );
}

export default Login;